import React, { memo, useCallback } from 'react';
import { HStack, Pressable } from 'native-base';
import { Iconography, Typography, logUserEvent } from 'fmc-digital-common';
import { useLipStore } from '../../../loaninprogress';
import { Platform } from 'react-native';
const SelectedFileRow = ({
  file,
  index,
  onPreview,
  url
}) => {
  const {
    removeFile,
    isDocUploading
  } = useLipStore(state => state);
  const onHandleDeleteFile = useCallback(() => {
    removeFile(index);
  }, [removeFile, index]);
  const preview = useCallback(() => {
    logUserEvent({
      action: 'PreviewClicked',
      type: 'LIPDocUploadPopUp',
      description: `Task Section Doc Upload Task ${file.uri}`.substring(0, 199)
    });
    if (onPreview) {
      onPreview(file);
    } else {
      if (Platform.OS === 'web') {
        //@ts-ignore
        window.open(url);
      }
    }
  }, [file, onPreview, url]);
  return /*#__PURE__*/React.createElement(HStack, {
    borderRadius: '4',
    backgroundColor: 'lightBlue.200',
    paddingX: '4',
    paddingY: '2',
    alignItems: 'center',
    flex: '1',
    marginTop: '1'
  }, /*#__PURE__*/React.createElement(HStack, {
    flex: '2'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: 'file-present',
    size: 24,
    color: "blue.500"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    marginLeft: '2',
    numberOfLines: 5
  }, file.name)), /*#__PURE__*/React.createElement(HStack, {
    flex: "1",
    justifyContent: 'flex-end',
    space: '2'
  }, /*#__PURE__*/React.createElement(Pressable, {
    disabled: isDocUploading,
    onPress: preview
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "preview",
    size: 20,
    color: "blue.900"
  })), /*#__PURE__*/React.createElement(Pressable, {
    onPress: onHandleDeleteFile,
    disabled: isDocUploading
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "delete",
    size: 20,
    color: "blue.500"
  }))));
};
export default /*#__PURE__*/memo(SelectedFileRow);
//# sourceMappingURL=index.js.map